import React, { Dispatch, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { StateAction } from "./state/actions/actions";
import { StateInterface } from "./state/reducer/store";
import { pdfjs, Page } from "react-pdf";
import { Document } from "react-pdf/dist/esm/entry.webpack";
import { Box, Button, CircularProgress, Grid } from "@material-ui/core";
import axios from "axios";
import { ContentState, EditorState } from "draft-js";
// pdfjs.GlobalWorkerOptions.workerSrc = "pdf.worker.min.js";

const PdfViewer = () => {
  const dispatch: Dispatch<StateAction> = useDispatch();
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const pdfFile = useSelector((state: StateInterface) => state.pdfFile);
  const isPdfConverting = useSelector(
    (state: StateInterface) => state.pdfIsConverting
  );
  function onDocumentLoadSuccess(props: any) {
    setNumPages(props.numPages);
  }
  const onConvertToPdfClick = async () => {
    if (!pdfFile) {
      console.log("PDF File does not exist");
      return;
    }
    const formData = new FormData();
    formData.append("file", pdfFile);
    try {
      dispatch({
        type: "SET_IS_FILE_CONVERTING",
        payload: true
      });
      const res = await axios.post('http://localhost:5000/pdftext', formData);
      const { text } = res.data;
      dispatch({
        type: "SET_TEXT_EDITOR_STATE",
        payload: EditorState.createWithContent(
          ContentState.createFromText(text)
        ),
      });
      dispatch({
        type: "SET_IS_FILE_CONVERTING",
        payload: false
      });
    } catch (e) {
      //DISPATCH PDF ERROR MESSAGE
      console.log(e);
    }
  };

  return (
    <Box style={{ marginBottom: 32 }}>
      <Grid
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
        container
      >
        <Button
          variant="contained"
          color="inherit"
          style={{
            backgroundColor: "green",
            color: "white",
          }}
          onClick={() =>
            setPageNumber((prev) => (prev - 1 === 0 ? prev : prev - 1))
          }
        >
          Previous Page
        </Button>

        <Button
          variant="contained"
          color="inherit"
          style={{
            backgroundColor: "#dc004e",
            color: "white",
            padding: 8,
          }}
          onClick={onConvertToPdfClick}
          disabled={isPdfConverting}
        >
          CONVERT PDF TO TEXT
          {isPdfConverting && (
            <CircularProgress style={{ marginLeft: 16 }} size={20} />
          )}
        </Button>

        <Button
          variant="contained"
          color="inherit"
          style={{ backgroundColor: "green", color: "white" }}
          onClick={() =>
            setPageNumber((prev) => (prev + 1 > numPages! ? prev : prev + 1))
          }
        >
          Next Page
        </Button>
      </Grid>
      <Box style={{ display: "flex", justifyContent: "center" }}>
        <p>
          Page {pageNumber} of {numPages}
        </p>
      </Box>

      <Document
        file={pdfFile}
        onLoadSuccess={onDocumentLoadSuccess}
        options={{
          workerSrc: `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`,
        }}
      >
        <Page pageNumber={pageNumber} />
      </Document>
    </Box>
  );
};

export default PdfViewer;
